var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab thermodynamic",class:{ active: _vm.tab == 'thermodynamic' },on:{"click":function($event){_vm.tab = 'thermodynamic'}}},[_vm._v("收割热力")]),_c('li',{staticClass:"tab progression",class:{ active: _vm.tab == 'progression' },on:{"click":function($event){_vm.tab = 'progression'}}},[_vm._v("收割进度")])])
}
var staticRenderFns = []

export { render, staticRenderFns }